export default class PlayerBeatFinalBossMessage {
	static protocol = {}

	constructor() {}
}
